import axios from 'axios';
import utils from '@/util/index';
import vue from '../main';

import {
  RESOURCE_BASE_URL,
  CLOUD_CLASS_BASE_URL,
  LOGIN_BASE_UTL,
} from './IPconfig';

//设置cross跨域 并设置访问权限 允许跨域携带cookie信息
axios.defaults.withCredentials = true;
// axios.defaults.timeout = 15000;
// //在main.js设置全局的请求次数，请求的间隙
// axios.defaults.retry = 4;
// axios.defaults.retryDelay = 1000;

//资源中心--------------------------------------------
export function resourceRequest() {
  // 创建axios实例
  const instance = axios.create({
    baseURL: RESOURCE_BASE_URL,
  });
  instance.defaults.timeout = 15000;
  instance.interceptors.request.use(
    (config) => reqSuccess(config),
    (error) => reqError(error)
  );
  instance.interceptors.response.use(
    (config) => resSuccess(config),
    (error) => resError(error)
  );
  // 发送真正的网络请求
  return instance;
}

//云课堂--------------------------------------------
export function cloudRequest() {
  // 创建axios实例
  const instance = axios.create({
    baseURL: CLOUD_CLASS_BASE_URL,
  });
  instance.defaults.timeout = 15000;
  instance.interceptors.request.use(
    (config) => reqSuccess(config),
    (error) => reqError(error)
  );
  instance.interceptors.response.use(
    (config) => resSuccess(config),
    (error) => resError(error)
  );
  // 发送真正的网络请求
  return instance;
}

//登录--------------------------------------------
export function loginRequest() {
  const instance = axios.create({
    baseURL: LOGIN_BASE_UTL,
  });
  // 创建axios实例
  instance.defaults.timeout = 15000;
  instance.interceptors.request.use(
    (config) => reqSuccess(config),
    (error) => reqError(error)
  );
  instance.interceptors.response.use(
    (config) => resSuccess(config),
    (error) => resError(error)
  );
  // 发送真正的网络请求
  return instance;
}

/**
 * 全部请求拦截
 * **/
function reqSuccess(config) {
  // 在发送请求之前做些什么
  //Authorization
  config.headers.Authorazition = sessionStorage.getItem('Authorazition') || '';
  config.headers.token = sessionStorage.getItem('loginMessage') || '';
  return config;
}

function reqError(error) {
  return error;
}

/**
 * 全部响应拦截
 * **/
function resSuccess(config) {
  console.log('resSuccess -> config', config);
  if (config.data.code == '登录已过期') {
    utils.tips('error', config.data.code);
    vue.$bus.exitLogin();
    vue.$router.push('/login');
  }
  // 在发送请求之前做些什么
  return config;
}

function resError(error) {
  console.log(error.response);
  return error;
}
